import React, { useEffect, useMemo, useState } from "react"
import TableView, { formatterRowComponent } from "../../../../../component/atoms/Tabel/index.jsx"
import { sortCaret } from "../../../../../_metronic/_helpers/index.js"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { Card } from "../../../../../_metronic/_partials/controls/Card.js"
import { EmptyCard, TableSkeleton } from "../../../../../component/index.jsx"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { useSelector } from "react-redux"
import { getUrlParsingPageFilter } from "../../../../../config/EndpointCollection.js"
import { useLocation } from "react-router-dom"
import { loadUserLogin } from "../../../../service/userManagementAction.js"
import { useTranslation } from "react-i18next"
import SVG from "react-inlinesvg"
import { DetailSvgIcon, EditSvgIcon } from "../../../../../component/atoms/Icons/SVG/index.jsx"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import {
  DATE_TYPE_ENUM,
  DOCUMENT_TYPE_ENUM,
  LABELING_CONST,
  MITRA_ACTIVE_CONTRACT_STATUS_ENUM,
  ROUTING_STATUS,
  isFrozen
} from "../../../../../constants/StringConstant.js"
import { PRIVILEGE_ENUM } from "../../../../../constants/PrivilegeConstants.js"
import { stringFormatting } from "../../../../helpers/TextHelper.js"
import SubMenuFilter from "../SubMenuFilter.jsx"
import { differenceInCalendarDays } from "date-fns"
import { getCountDownToday } from "../../../../helpers/StringCollection.js"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import { MITRA } from "../../../../../constants/InitTypeConstants.js"

export function Active({
  data,
  changePage,
  history,
  general,
  initialFilterTable,
  isFilter,
  status,
  handleChangeSubTab,
  initialActive,
  isMultiSelect = false,
  actionType = null,
  onSelectionChange = () => {}
}) {
  const privileges = loadUserLogin().privilege
  const { General } = useSelector((state) => state)
  const { t } = useTranslation()
  const location = useLocation()

  const [subTabActive, setSubTabActive] = useState(MITRA_ACTIVE_CONTRACT_STATUS_ENUM[initialActive])
  const [selectedRows, setSelectedRows] = useState([])
  const [selectedIds, setSelectedIds] = useState([])

  const columns = [
    {
      dataField: "code",
      text: t("label_mitra_id"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <div className="text-dark font-weight-bolder mb-1 font-size-lg">
            {stringFormatting(e.mitra_code)}
          </div>
        )
      },
      sortCaret: sortCaret,
      sort: true,
      onSort: (field, order) => {
        let param = getUrlParsingPageFilter({
          ...initialFilterTable,
          sort: field + "," + order
        })
        history.push({ pathname: location.pathname, search: param })
      }
    },
    {
      dataField: "name",
      text: t("label_name"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiName
      },
      sortCaret: sortCaret,
      sort: true,
      onSort: (field, order) => {
        let param = getUrlParsingPageFilter({
          ...initialFilterTable,
          sort: field + "," + order
        })
        history.push({ pathname: location.pathname, search: param })
      },
      headerStyle: () => {
        return { width: "25%" }
      }
    },
    {
      dataField: "subRegional",
      text: t("label_sub_regional"),
      formatter: formatterRowComponent,
      sortCaret: sortCaret,
      formatExtraData: {
        externalStyle: (e) => <>{stringFormatting(e?.sub_regional_name)}</>
      }
    },
    {
      dataField: "type",
      text: t("label_mitra_type"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => <div className="text-dark">{stringFormatting(e.mitra_type)}</div>
      },
      sortCaret: sortCaret,
      onSort: (field, order) => {
        let param = getUrlParsingPageFilter({
          ...initialFilterTable,
          sort: field + "," + order
        })
        history.push({ pathname: location.pathname, search: param })
      }
    },
    {
      dataField: "missing_document_types",
      text: t("table_header_missing_document"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <div className="text-dark text-center">
            {e?.missing_document_types?.length > 0
              ? e.missing_document_types.map((type) => {
                if (type === DOCUMENT_TYPE_ENUM.CONTRACT) {
                  return t("contract")
                } else if (type === DOCUMENT_TYPE_ENUM.TAX_ID) {
                  return t("label_npwp_tax_id")
                }
              }).filter(Boolean).join(", ")
              : "-"}
          </div>
        )
      }
    },
    {
      dataField: "contract_date_end",
      text: t("table_header_contract_end"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiContractStatus
      }
    },
    {
      dataField: "action",
      text: "Action",
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAction
      }
    }
  ]

  function uiAction(e) {
    return (
      <>
        {privileges.indexOf(PRIVILEGE_ENUM.DETAIL_MITRA_REGISTERED) > -1 && (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}>
            <div
              className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-3"
              onClick={() =>
                history.push(
                  RoutesConstants.MITRA.DETAIL_MITRA(ROUTING_STATUS.STATUS_STRING.ACTIVE, e?.id)
                )
              }>
              <DetailSvgIcon />
            </div>
          </OverlayTrigger>
        )}
        {privileges.indexOf(PRIVILEGE_ENUM.UPDATE_MITRA) > -1 && (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}>
            <div
              className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-3"
              onClick={() => history.push(RoutesConstants.MITRA.EDIT_MITRA(status, e.id))}>
              <EditSvgIcon />
            </div>
          </OverlayTrigger>
        )}
      </>
    )
  }

  function uiName(e) {
    return (
      <>
        <div className="d-flex align-items-start mb-1">
          <a className="text-dark font-weight-bolder font-size-lg">
            {stringFormatting(e?.mitra_name)}
          </a>
          {isFrozen(e?.mitra_status) && (
            <SVG src={ICON_CONSTANTS.FREEZE_STATUS} className="ml-2" />
          )}
          {e?.mitra_status === LABELING_CONST.BLACKLISTED && (
            <SVG src={ICON_CONSTANTS.BLACKLIST_STATUS} className="ml-2" />
          )}
        </div>
        {privileges.indexOf(PRIVILEGE_ENUM.MITRA_PHONE_NUMBER) > -1 && (
          <span className="text-muted font-weight-bold d-block">
            {stringFormatting(e?.mitra_phone)}
          </span>
        )}
      </>
    )
  }

  function uiContractStatus(e) {
    const dateDiff = differenceInCalendarDays(new Date(e.contract_date_end), new Date()) || 0

    return (
      <>
        <a className="text-dark font-weight-bolder mb-1 font-size-lg">
          {e.contract_date_end
            ? timeStampToDate(e.contract_date_end, DATE_TYPE_ENUM.ISO_DATE_STRAP)
            : "-"}
        </a>
        {e.contract_date_end && (
          <span
            className={`font-weight-bold d-block ${
              dateDiff <= 0 ? "text-danger" : dateDiff > 30 ? "text-muted" : "text-warning"
            }`}>
            {getCountDownToday(dateDiff, t("label_contract_end"))}
          </span>
        )}
      </>
    )
  }

  useEffect(() => {
    if (initialActive) {
      setSubTabActive(initialActive)
    }
  }, [initialActive])

  useEffect(() => {
    setSelectedRows([])
    setSelectedIds([])
    onSelectionChange([])
  }, [isMultiSelect, actionType, onSelectionChange])

  const nonSelectableIds = useMemo(() => {
    if (!actionType || !data?.pageData) return []
    if (actionType === LABELING_CONST.FREEZE || actionType === LABELING_CONST.BLACKLIST) {
      return data.pageData
        .filter((row) => isFrozen(row.mitra_status) || row.mitra_status === LABELING_CONST.BLACKLISTED)
        .map((row) => row.id)
    }
    if (actionType === LABELING_CONST.UNFREEZE) {
      return data.pageData
        .filter((row) => !isFrozen(row.mitra_status))
        .map((row) => row.id)
    }
    return []
  }, [actionType, data?.pageData])

  function handleSelect(row, isSelected) {
    const updated = isSelected
      ? [...selectedRows, row]
      : selectedRows.filter((r) => r.id !== row.id)
    setSelectedRows(updated)
    setSelectedIds(updated.map((r) => r.id))
    onSelectionChange(updated)
  }

  function handleSelectAll(isSelect, rows) {
    const updated = isSelect ? rows : []
    setSelectedRows(updated)
    setSelectedIds(updated.map((r) => r.id))
    onSelectionChange(updated)
  }

  return (
    <>
      {initialActive && (
        <SubMenuFilter
          onClick={(data) => {
            handleChangeSubTab(data)
            setSubTabActive(data)
          }}
          key={initialActive}
          initialActive={MITRA_ACTIVE_CONTRACT_STATUS_ENUM[initialActive]}
        />
      )}

      <Card className="p-12 card-custom card-shadowless">
        {(General?.loading && General?.actionInitType === MITRA.GET_LIST_MITRA) ? (
          <TableSkeleton column={5} row={10} />
        ) : data?.pageData.length == 0 ? (
          <EmptyCard
            subtitle={isFilter ? t("messages_response_empty_search_subtitle") : ""}
            image={
              isFilter
                ? ILLUSTRATION_CONSTANTS.EMPTY_STATE_NO_DATA
                : ILLUSTRATION_CONSTANTS.EMPTY_STATE
            }
            body={
              isFilter
                ? t("messages_response_searching_not_found")
                : t("messages_response_empty_state", { name: "mitra" })
            }
          />
        ) : (
          ""
        )}
        <TableView
          key={`${subTabActive}-${isMultiSelect}`}
          callbackAfterPageChange={changePage}
          columnProperties={columns}
          dataTable={data?.pageData ?? []}
          currentPage={data?.page?.currentPage ?? 1}
          currentElement={data?.page?.currentElement ?? 10}
          totalCount={data?.page?.totalCount ?? 0}
          loadingGetData={general?.loading && general?.actionInitType === MITRA.GET_LIST_MITRA}
          actionInitType={MITRA.GET_LIST_MITRA}
          ignoreSinglePage
          rowClasses={() => {
            return "cursor-pointer"
          }}
          keyField="id"
          selectable={isMultiSelect}
          onSelect={handleSelect}
          onSelectAll={handleSelectAll}
          selected={selectedIds}
          nonSelectable={nonSelectableIds}
          headerColumnStyle={{ width: 40 }}
        />
      </Card>
    </>
  )
}
